"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoeConnectionStatusResponseStatusEnum = exports.JoeConnectionStatusResponseToJSON = exports.JoeConnectionStatusResponseFromJSONTyped = exports.JoeConnectionStatusResponseFromJSON = void 0;
function JoeConnectionStatusResponseFromJSON(json) {
    return JoeConnectionStatusResponseFromJSONTyped(json, false);
}
exports.JoeConnectionStatusResponseFromJSON = JoeConnectionStatusResponseFromJSON;
function JoeConnectionStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': json['status'],
    };
}
exports.JoeConnectionStatusResponseFromJSONTyped = JoeConnectionStatusResponseFromJSONTyped;
function JoeConnectionStatusResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': value.status,
    };
}
exports.JoeConnectionStatusResponseToJSON = JoeConnectionStatusResponseToJSON;
/**
* @export
* @enum {string}
*/
var JoeConnectionStatusResponseStatusEnum;
(function (JoeConnectionStatusResponseStatusEnum) {
    JoeConnectionStatusResponseStatusEnum["NoConnection"] = "no_connection";
    JoeConnectionStatusResponseStatusEnum["ConnectionEstablished"] = "connection_established";
})(JoeConnectionStatusResponseStatusEnum = exports.JoeConnectionStatusResponseStatusEnum || (exports.JoeConnectionStatusResponseStatusEnum = {}));
//# sourceMappingURL=JoeConnectionStatusResponse.js.map